import { ParsedUrlQuery } from "querystring";
import { ENVIRONMENT, ROOT_HOST } from "../constants/env/internalService.constants";
import { GenericObject } from "../types/common.types";
import isBrowser from "./next.util";

/**
 * True when the current page is being served from the configured marketing
 * root host. Used to gate UTM capture / cleanup so we don't accidentally
 * mutate localStorage on creator subdomains or other embedded contexts.
 *
 * Tolerates both forms of `NEXT_PUBLIC_ROOT_HOST`:
 *  - full URL (e.g. `https://www.graphy.com`) — current production value
 *  - bare host (e.g. `www.graphy.com`) — older format some consumers still
 *    expect
 *
 * Also normalises the leading `www.` on both sides — `graphy.com` and
 * `www.graphy.com` should be treated as the same marketing root, otherwise
 * a visit to the apex domain silently drops UTM attribution.
 *
 * On the server, returns `true` so SSR-safe callers don't short-circuit.
 */
const stripWww = (host: string) => host.replace(/^www\./i, "");

export const isRunningOnRootHost = (): boolean => {
  if (!isBrowser()) return true;
  if (!ROOT_HOST) return true;
  let rootHost = ROOT_HOST;
  try {
    rootHost = new URL(ROOT_HOST).host;
  } catch {
    // ROOT_HOST is a bare host, not a URL — fall through with original value.
  }
  return stripWww(window.location.host) === stripWww(rootHost);
};


export const getQueryObjFromURL = (): GenericObject => {
  const paramsObj: GenericObject = {};

  if (isBrowser()) {
    const params = new URLSearchParams(window.location.search);

    for (let [key, val] of params.entries()) {
      paramsObj[key] = val;
    }
  }
  return paramsObj;
};

export const getPathName = (path: string) => {
  return path.replace(/^\//, "");
};

export const getHostName = (req: any) =>
  isBrowser() ? window.location.host : req?.headers?.host;

export const getProtocol = () => {
  if (ENVIRONMENT === "development") return "http";
  return "https";
};

export const getIsSuccessPage = (query: ParsedUrlQuery): boolean => {
  if(query.page === 'webinar-rebecca-schocker' && query.webinar_success === 'true') return true;
  if(query.page === 'webinar-brooke-harris' && query.webinar_success === 'true') return true;

  return false
};